export default "__VITE_ASSET__iD4SExvG__"